<template lang="pug">
.send-request-reply-message(:class="_getAlignClass")
  .message(:class="_getMessageClass" style="max-width: 90%;").pt-1.pr-2.pb-1.pl-2
    .d-flex.flex-row.align-items-center.mr-2.mb-2
      .datetime.mr-2 {{ _datetime }}
      .acceptance.mr-2 {{ _acceptance }}
    .text.pre-line {{ _messageText }}
  
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import { OtherOfficeAcceptanceRequestReply, Acceptance } from "@/commons/services/OtherOfficeAcceptanceRequestReplies";

/**
 * ### 返信状況タブの施設情報コンポーネント
 */
@Component
export default class SendRequestReplyMessage extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: OtherOfficeAcceptanceRequestReply | null;

  get _getAlignClass(): string {
    if (!this.value) {
      return "";
    }
    // 自施設が送信した返信なら右寄せ、そうでなければ左寄せ
    return this.value.senderFacilityId == userStore.facility.id ? "d-flex justify-content-end" : "d-flex justify-content-start";
  }

  get _getMessageClass(): string {
    if (!this.value) {
      return "";
    }
    // 自施設が送信した返信か否かで吹き出しの色を変える
    return this.value.senderFacilityId == userStore.facility.id ? "mine-message" : "theirs-message";
  }

  get _datetime(): string {
    if (!this.value) {
      return "";
    }
    return this.$dateUtil.convertNumberToString(Number(this.value.datetime), "yyyy/mm/dd hh:MM");
  }

  get _acceptance(): string {
    if (!this.value || !this.value.acceptance) {
      return "";
    }
    switch (this.value.acceptance) {
      case Acceptance.POSSIBLE: {
        return "受け入れ可";
      }
      case Acceptance.NEED_CONSULTATION: {
        return "詳細確認希望";
      }
      case Acceptance.NOT_POSSIBLE: {
        return "受け入れ不可";
      }
      default: {
        return "";
      }
    }
  }

  get _messageText(): string {
    return this.value && this.value.messageText ? this.value.messageText : "";
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.send-request-reply-message {
  .message {
    border: 0;
    border-radius: 0.5rem;

    .text {
      word-break: break-all;
    }

    .datetime {
      font-size: 14px;
    }
    &.mine-message {
      background-color: $bg-message-mine;
      color: rgba(255, 255, 255, 1);

      .datetime {
        color: rgba(222, 242, 242, 1);
      }
    }
    &.theirs-message {
      background-color: $bg-message-bot;

      .datetime {
        color: $font-disable-font-color;
      }
    }
    .acceptance {
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>
